import { CliOauthResult } from "pages/cli-oauth-result";

const CliOauthDone: React.FC = (): JSX.Element => (
  <CliOauthResult
    message={"You can close this tab and return to the CLI."}
    title={"Sign in complete"}
  />
);

export { CliOauthDone };
